import React from "react";
import {connect} from "react-redux";

import {getCheckoutStatus, getCheckoutError, getCheckoutErrorCode} from "state/school_money/selectors";
import {closeCheckout, clearCheckoutError, checkoutRestart} from "state/school_money/actions";
import Checkout from "state/school_money/entities/Checkout";

import ModalDialog from "components/ModalDialog";
import Button from "components/Button";
import Spinner from "components/Spinner";

import "./CheckoutInformationModal.css";

const errorMessage = {
  PROGRAMMING_ERROR: "Programming error occurred.",
  ERROR_CONNECTION: "There was a problem connecting to the payment servers.",
  ERROR_UNABLE_TO_PROCESS_PAYMENT: "Unable to process your payment.",
  ERROR_CARD_DETAILS_INCORRECT: "There was a problem with the details provided.",
  ERROR_PROCESS_PAYMENT: "There was an issue processing the payment.",
  ERROR_AUTHORISE_PAYMENT: "There was a problem when trying to authorise the payment.",
  DUPLICATE_TRANSACTION: "This transaction has already been completed.",
  INVALID_AMOUNT: "There was a problem with initialising your transaction.",
  SERVER_ERROR: "An unknown error has occurred.",
  INVALID_RESPONSE: "There was an issue processing the payment response from the provider.",
  API_ERROR: "The payment was unsuccessful.",
  ISSUING_BANK_SYSTEM_ERROR: "The issuing bank returned a system error.",
  ERROR_ISSUING_BANK_DECLINED_PAYMENT: "The issuing bank declined the payment.",
  UNKNOWN_ERROR: "An issue occurred with initiating your payment.",
  INIT_FAIL: "An issue occurred with initiating your payment. Please refresh and try again.",
  BUYER_ACCOUNT_ERROR: "Unable to collect your Google pay details. Please refresh and try again.",
  MERCHANT_ACCOUNT_ERROR: "The site that accesses the Google Pay API doesn't have the right permission.",
  GOOGLE_PAY_INVALID_CARD_DETAILS: "Invalid card details were provided."
}

/**
 * Display success or error messages about the checkout process.
 */
class CheckoutInformationModal extends React.Component {

  getErrorMessage(error, errorCode) {

    const errorDescription = errorMessage[error] || "";
    const errorCodeDescription = (errorCode !== null && errorCode !== undefined) ? " Error code: " + errorCode + "." : "";
    return errorDescription + errorCodeDescription;
  }

  getActionMessage(error){
    return error === "DUPLICATE_TRANSACTION" ? "Please contact product support." : "Please check your details and try again.";
  }

  clearError = () => {
      this.props.clearError();
      this.props.close();
  }

  checkoutRestart = () => {
    this.props.checkoutRestart();
  }

  getContent(status, error, errorCode) {

    if (error !== null) {
      return (
        <div className="checkout-info-modal">
          <h1 className="checkout-info-modal__heading">Oops!</h1>
          <div className="checkout-info-modal__body">
            <p>There was a problem processing your details.</p>
            <p>{this.getErrorMessage(error, errorCode)}</p>
            <p>{this.getActionMessage(error)}</p>
          </div>
          <div className="checkout-info-modal__button-container">
            <Button className="checkout-info-modal__next-button" onClick={this.checkoutRestart}>Try Again</Button>
            <Button className="checkout-info-modal__cancel-button" onClick={this.clearError}>Cancel</Button>
          </div>
        </div>
      )
    }

    switch (status) {
      case Checkout.status.PREPARING:
        return (
          <div className="checkout-info-modal">
            <h1 className="checkout-info-modal__heading">Preparing</h1>
            <div className="checkout-info-modal__body">
              <p>Please wait while we prepare your payment.</p>
            </div>
            <div className="checkout-info-modal__spinner">
              <Spinner size="standalone" color="school_money" />
            </div>
          </div>
        )
      case Checkout.status.PROCESSING:
        return (
          <div className="checkout-info-modal">
            <h1 className="checkout-info-modal__heading">Processing</h1>
            <div className="checkout-info-modal__body">
              <p>Please wait while we process your payment.</p>
            </div>
            <div className="checkout-info-modal__spinner">
              <Spinner size="standalone" color="school_money" />
            </div>
          </div>
        )
      default:
        return null;
    }

  }

  render() {

    const {status, error, errorCode} = this.props;

    const content = this.getContent(status, error, errorCode);
    if (content === null) {
      return null;
    }

    return (
      <ModalDialog>
        {content}
      </ModalDialog>
    )

  }

}

export default connect(
  state => ({
    status: getCheckoutStatus(state),
    error: getCheckoutError(state),
    errorCode: getCheckoutErrorCode(state)
  }),
  {
    close: closeCheckout,
    clearError: clearCheckoutError,
    checkoutRestart: checkoutRestart
  }
)(CheckoutInformationModal);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/checkout/CheckoutInformationModal.js